module.exports = __webpack_public_path__ + "static/media/crown.76a73f1d.svg";